import { createSlice, createAsyncThunk, current } from "@reduxjs/toolkit";
import { functionalAdminUrls } from "./functionalAdminUtils";
import { apiUrls } from "../../library/Utils";
import { object } from "@amcharts/amcharts5";

export const GetUserCountries = createAsyncThunk(
    "functionalAdmin/GetUserCountries",
    async (obj, { dispatch, getState }) => {
        let reqOptions = {};
        const data = JSON.parse(localStorage.getItem("data"));
        reqOptions.method = obj.method;
        let url = apiUrls.countryListUrl + data.userID;
        return fetch(url, reqOptions).then((r) => {
            return r.json();
        });
    }
);

export const GetSKUSwitchSearch = createAsyncThunk(
    "functionalAdmin/GetSKUSwitchSearch",
    async (obj, thunkAPI) => {
        const data = JSON.parse(localStorage.getItem("data"));
        const token = data.token;
        const userID = data.userID;
        const url = functionalAdminUrls.getSKUSwitchSearch + "CountryID=" + obj.countryID + "&ProductName=" + obj.productName + "&SKUType=1";
        try {
            const response = await fetch(url, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                    Accept: "application/json",
                },
            });
            const jsonData = await response.json();
            return jsonData;
        } catch (error) {
            console.error("Error: ", error);
        }
    }
);

export const GetGroupOrScenarioDetails = createAsyncThunk(
    "functionalAdmin/GetGroupOrScenarioDetails",
    async (obj, thunkAPI) => {
        const data = JSON.parse(localStorage.getItem("data"));
        const token = data.token;
        const userID = data.userID;
        const url = functionalAdminUrls.getGroupScenario + "GeoID=" + obj.countryID + "&GroupOrScenarioType=" + obj.viewBy;
        try {
            const response = await fetch(url, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                    Accept: "application/json",
                },
            });
            const jsonData = await response.json();
            return jsonData;
        } catch (error) {
            console.error("Error: ", error);
        }
    }
);

export const GetCustomersToRename_Pagination = createAsyncThunk(
    "functionalAdmin/GetCustomersToRename_Pagination",
    async (obj, thunkAPI) => {
        const data = JSON.parse(localStorage.getItem("data"));
        const token = data.token;
        const userID = data.userID;
        const url = functionalAdminUrls.getCustomersToRename + "geoId=" + obj.countryID + "&customerName=" + obj.customerName
        + "&pageIndex=" + obj.pageIndex + "&pageSize=" + obj.pageSize;
        try {
            const response = await fetch(url, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                    Accept: "application/json",
                },
            });
            const jsonData = await response.json();
            return jsonData;
        } catch (error) {
            console.error("Error: ", error);
        }
    }
);

export const GetCustomerGroupReferenceData = createAsyncThunk(
    "functionalAdmin/GetCustomerGroupReferenceData",
    async (obj, thunkAPI) => {
        const data = JSON.parse(localStorage.getItem("data"));
        const token = data.token;
        const userID = data.userID;
        const url = functionalAdminUrls.getCustomerGroupRefData + `?CountryId=${obj.CountryID}`;
        try {
            const response = await fetch(url, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                    Accept: "application/json",
                },
            });
            const jsonData = await response.json();
            return jsonData;
        } catch (error) {
            console.error("Error: ", error);
        }
    }
);

export const UpdateCustomerData = createAsyncThunk(
    "functionalAdmin/updateCustomerData",
    async (obj, thunkAPI) => {
        const data = JSON.parse(localStorage.getItem("data"));
        const token = data.token;
        const userID = data.userID;
        const url = functionalAdminUrls.updateCustomerData + `customerId=${obj.customerID}&geoName=${obj.countryName}&clientCustomerCode=${obj.clientCustomerCode}&customerName=${obj.customerName}`;
        try {
            const response = await fetch(url, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                    Accept: "application/json",
                },
            });
            const jsonData = await response.json();
            return jsonData;
        } catch (error) {
            console.error("Error: ", error);
        }
    }
);

export const GetCustomerCount = createAsyncThunk(
    "functionalAdmin/GetCustomerCount",
    async (obj, thunkAPI) => {
        const data = JSON.parse(localStorage.getItem("data"));
        const token = data.token;
        const userID = data.userID;
        const url = functionalAdminUrls.getCustomerCount + `geoId=${obj.geoId}&customerName=${obj.customerName}`;
        try {
            const response = await fetch(url, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                    Accept: "application/json",
                },
            });
            const jsonData = await response.json();
            return jsonData;
        } catch (error) {
            console.error("Error: ", error);
        }
    }
);

export const SearchCustomerTrustLevel = createAsyncThunk(
    "functionalAdmin/SearchCustomerTrustLevel",
    async (obj, thunkAPI) => {
        const data = JSON.parse(localStorage.getItem("data"));
        const token = data.token;
        const userID = data.userID;
        const {CountryID, CustomerCodeType, CustomerName, PartnerType } = obj;
        const url = functionalAdminUrls.searchCustomerTrustLevel + `CountryID=${CountryID}&CustomerTypeCode=${CustomerCodeType}&CustomerName=${CustomerName}&PartnerType=${PartnerType}`;
        try {
            const response = await fetch(url, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                    Accept: "application/json",
                },
            });
            const jsonData = await response.json();
            return jsonData;
        } catch (error) {
            console.error("Error: ", error);
        }
    }
);

export const UpdateCustomerTrustLevel = createAsyncThunk(
    "functionalAdmin/UpdateCustomerTrustLevel",
    async (arr, { dispatch, getState }) => {
        const data = JSON.parse(localStorage.getItem("data"));
        const token = data.token;
        const url = functionalAdminUrls.updateCustomerTrustLevel;
        // const myArr = [];
        // myArr.push(obj);
        try {
            const response = await fetch(url, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                    Accept: "application/json",
                },
                body: JSON.stringify(arr),
            });
            const jsonData = await response.json();
            return jsonData;
        } catch (error) {
            console.error("Error: ", error);
        }
    }
);

export const UpdateGroupOrScenarioActivation = createAsyncThunk(
    "functionalAdmin/UpdateGroupOrScenarioActivation",
    async (obj, thunkAPI) => {
        const data = JSON.parse(localStorage.getItem("data"));
        const token = data.token;
        const userID = data.userID;
        const {GroupOrScenarioID, GroupOrScenarioType, Inactive, Activity, criticalityID, PeriodType, sticktoQuota } = obj;
        const url = functionalAdminUrls.updateGroupOrScenarioActivation + 
        `GroupOrScenarioID=${GroupOrScenarioID}&GroupOrScenarioType=${GroupOrScenarioType}&Inactive=${Inactive}&Activity=${Activity}&criticalityID=${criticalityID}&PeriodType=${PeriodType}&sticktoQuota=${sticktoQuota}`;
        try {
            const response = await fetch(url, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                    Accept: "application/json",
                },
            });
            const jsonData = await response.json();
            return jsonData;
        } catch (error) {
            console.error("Error: ", error);
        }
    }
);

export const ListUpdateGroupOrScenario = createAsyncThunk(
    "functionalAdmin/ListUpdateGroupOrScenario",
    async (arr, { dispatch, getState }) => {
        const data = JSON.parse(localStorage.getItem("data"));
        const token = data.token;
        const url = functionalAdminUrls.listUpdateGroupOrScenario;
        // const myArr = [];
        // myArr.push(obj);
        try {
            const response = await fetch(url, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                    Accept: "application/json",
                },
                body: JSON.stringify(arr),
            });
            const jsonData = await response.json();
            return jsonData;
        } catch (error) {
            console.error("Error: ", error);
        }
    }
);


//http://172.19.79.4/takedasimswave3_api/api/Admin/UpdateGroupOrScenarioActivation?GroupOrScenarioID=10000052&GroupOrScenarioType=1&Inactive=0&Activity=Deactivation&criticalityID=0&PeriodType=null&sticktoQuota=0

const initialState = {
    isLoading: false,
    isSuccess: false,
    isFailed: false,
    isError: false,
    countries: [],
    selectedCountry: "",
    selectedCountryID: null,
    getSKUData: [],
    getGroupScenarioData: [],
    getCustomerRenameData: [],
    getCustomerGroupRefData : {},
    updateCustomer: null,
    customerCount: 0,
    customerTrustLevelData: [],
    updateCustomerTrust: null,
    listUpdateGroupOrScenario: null,
    clearGroupScenarioData: false,
    clearCustomerRename: false,
    clearCustomerTrustLevel: false,
    message: "",
	severity: "",
	messageOpen: false,

}

const functionalAdminSlice = createSlice({
    name: "review",
    initialState,
    reducers: {
        setState: {
            prepare(stateName, stateValue) {
                return {
                    payload: { stateName, stateValue },
                };
            },
            reducer(state, action) {
                const { stateName, stateValue } = action.payload;
                state[stateName] = stateValue;
            },
        },
    },
    extraReducers: (builder) => {
        builder.addCase(GetUserCountries.pending, (state, action) => {
            state.isLoading = true;
        }).
            addCase(GetUserCountries.fulfilled, (state, { payload }) => {
                state.countries = payload;
                state.isLoading = false;
            }).addCase(GetUserCountries.rejected, (state, action) => {
                state.isLoading = false;
                console.log("Error from GetUserCountries", action.error.message)
            })

            .addCase(GetGroupOrScenarioDetails.pending, (state, action) => {
                state.isLoading = true;
            }).
            addCase(GetGroupOrScenarioDetails.fulfilled, (state, { payload }) => {
                state.getGroupScenarioData = payload;
                state.isLoading = false;
            }).addCase(GetGroupOrScenarioDetails.rejected, (state, action) => {
                state.isLoading = false;
                console.log("Error from GetGroupOrScenarioDetails", action.error.message)
            })

            .addCase(GetCustomersToRename_Pagination.pending, (state, action) => {
                state.isLoading = true;
            }).
            addCase(GetCustomersToRename_Pagination.fulfilled, (state, { payload }) => {
                state.getCustomerRenameData = payload;
                state.isLoading = false;
            }).addCase(GetCustomersToRename_Pagination.rejected, (state, action) => {
                state.isLoading = false;
                console.log("Error from GetCustomersToRename_Pagination", action.error.message)
            })

            .addCase(GetCustomerGroupReferenceData.pending, (state, action) => {
                state.isLoading = true;
            }).
            addCase(GetCustomerGroupReferenceData.fulfilled, (state, { payload }) => {
                state.getCustomerGroupRefData = payload;
                state.isLoading = false;
            }).addCase(GetCustomerGroupReferenceData.rejected, (state, action) => {
                state.isLoading = false;
                console.log("Error from GetCustomerGroupReferenceData", action.error.message)
            })

            .addCase(UpdateCustomerData.pending, (state, action) => {
                state.isLoading = true;
            }).
            addCase(UpdateCustomerData.fulfilled, (state, { payload }) => {
                state.updateCustomer = payload;
                state.isLoading = false;
            }).addCase(UpdateCustomerData.rejected, (state, action) => {
                state.isLoading = false;
                console.log("Error from UpdateCustomerData", action.error.message)
            })

            .addCase(GetCustomerCount.pending, (state, action) => {
                state.isLoading = true;
            }).
            addCase(GetCustomerCount.fulfilled, (state, { payload }) => {
                state.customerCount = payload;
                state.isLoading = false;
            }).addCase(GetCustomerCount.rejected, (state, action) => {
                state.isLoading = false;
                console.log("Error from UpdateCustomerData", action.error.message)
            })

            //SearchCustomerTrustLevel
            .addCase(SearchCustomerTrustLevel.pending, (state, action) => {
                state.isLoading = true;
            }).
            addCase(SearchCustomerTrustLevel.fulfilled, (state, { payload }) => {
                state.customerTrustLevelData = payload;
                state.isLoading = false;
            }).addCase(SearchCustomerTrustLevel.rejected, (state, action) => {
                state.isLoading = false;
                console.log("Error from UpdateCustomerData", action.error.message)
            })

            //UpdateCustomerTrustLevel
            .addCase(UpdateCustomerTrustLevel.pending, (state, action) => {
                state.isLoading = true;
            }).
            addCase(UpdateCustomerTrustLevel.fulfilled, (state, { payload }) => {
                state.updateCustomerTrust = payload;
                state.isLoading = false;
            }).addCase(UpdateCustomerTrustLevel.rejected, (state, action) => {
                state.isLoading = false;
                console.log("Error from UpdateCustomerData", action.error.message)
            })

            //ListUpdateGroupOrScenario
            .addCase(ListUpdateGroupOrScenario.pending, (state, action) => {
                state.isLoading = true;
            }).
            addCase(ListUpdateGroupOrScenario.fulfilled, (state, { payload }) => {
                state.listUpdateGroupOrScenario = payload;
                state.isLoading = false;
            }).addCase(ListUpdateGroupOrScenario.rejected, (state, action) => {
                state.isLoading = false;
                console.log("Error from UpdateCustomerData", action.error.message)
            })
    }
});

export const {
    // setCountries,
    setState
} = functionalAdminSlice.actions;

export default functionalAdminSlice.reducer;